import { render } from "./BaseFormItem.vue?vue&type=template&id=0de3e8ca&scoped=true"
import script from "./BaseFormItem.vue?vue&type=script&lang=js"
export * from "./BaseFormItem.vue?vue&type=script&lang=js"

import "./BaseFormItem.vue?vue&type=style&index=0&id=0de3e8ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de3e8ca"]])

export default __exports__